export default __webpack_public_path__ + "static/media/menu.2c524878.svg";